// extracted by mini-css-extract-plugin
export default {"ourWhatImg":"LeadershipOurWhat_ourWhatImg__v3PH4"};